module.exports = __webpack_public_path__ + "static/media/San_Jose_Sharks.ad075456.svg";